import React, { useState } from "react";
import sampleProducts from "../data/sampleProducts";
import "./HomePage.css";

function HomePage({ addToCart }) {
  const [search, setSearch] = useState("");

  // Filter products by search input
  const filteredProducts = sampleProducts.filter((product) => {
    const query = search.toLowerCase();
    return (
      product.name.toLowerCase().includes(query) ||
      product.category.toLowerCase().includes(query)
    );
  });

  return (
    <div className="home-page">
      <h1 className="page-title">Compare Products</h1>

      {/* Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search for phones, laptops..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Product Grid */}
      <div className="home-product-grid">
        {filteredProducts.map((product) => (
          <div className="product-card" key={product.id}>
            <div className="image-container">
              <img
                src={product.image}
                alt={product.name}
                className="product-img"
                onError={(e) =>
                  (e.target.src =
                    "https://picsum.photos/200?random=" + product.id)
                }
              />
              <div className="image-overlay">
                <p>{product.description}</p>
              </div>
            </div>
            <h3>{product.name}</h3>
            <p>${product.price.toFixed(2)}</p>
            <button className="add-btn" onClick={() => addToCart(product)}>
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
